export const resources = {
  junior: {
    macos: [
      { name: 'React Documentation', url: 'https://react.dev/learn', type: 'frontend' },
      { name: 'Node.js Guide', url: 'https://nodejs.org/en/docs/guides/', type: 'backend' },
      { name: 'MDN Web Docs', url: 'https://developer.mozilla.org/', type: 'web-fundamentals' },
      { name: 'Fullstack Open Course', url: 'https://fullstackopen.com/', type: 'course' }
    ],
    windows: [
      { name: 'React Documentation', url: 'https://react.dev/learn', type: 'frontend' },
      { name: 'ASP.NET Core Tutorial', url: 'https://docs.microsoft.com/aspnet/core/', type: 'backend' },
      { name: 'Visual Studio Code Tips', url: 'https://code.visualstudio.com/docs', type: 'tools' },
      { name: 'C# Programming Guide', url: 'https://docs.microsoft.com/dotnet/csharp/', type: 'language' }
    ],
    linux: [
      { name: 'Linux Development Setup', url: 'https://www.digitalocean.com/community/tutorials', type: 'system' },
      { name: 'Docker for Developers', url: 'https://docs.docker.com/get-started/', type: 'containerization' },
      { name: 'PostgreSQL Tutorial', url: 'https://www.postgresql.org/docs/', type: 'database' },
      { name: 'Nginx Configuration', url: 'https://nginx.org/en/docs/', type: 'server' }
    ]
  },
  mid: {
    macos: [
      { name: 'Next.js Documentation', url: 'https://nextjs.org/docs', type: 'framework' },
      { name: 'System Design Interview', url: 'https://github.com/donnemartin/system-design-primer', type: 'architecture' },
      { name: 'TypeScript Handbook', url: 'https://www.typescriptlang.org/docs/', type: 'language' },
      { name: 'GraphQL Best Practices', url: 'https://graphql.org/learn/best-practices/', type: 'api' }
    ],
    windows: [
      { name: 'Blazor Documentation', url: 'https://docs.microsoft.com/aspnet/core/blazor/', type: 'framework' },
      { name: 'Azure Architecture Patterns', url: 'https://docs.microsoft.com/azure/architecture/', type: 'cloud' },
      { name: 'Entity Framework Core', url: 'https://docs.microsoft.com/ef/core/', type: 'orm' },
      { name: 'SignalR Real-time Apps', url: 'https://docs.microsoft.com/aspnet/signalr/', type: 'realtime' }
    ],
    linux: [
      { name: 'Kubernetes for Developers', url: 'https://kubernetes.io/docs/concepts/', type: 'orchestration' },
      { name: 'Microservices Patterns', url: 'https://microservices.io/patterns/', type: 'architecture' },
      { name: 'Redis Caching Strategies', url: 'https://redis.io/docs/manual/patterns/', type: 'caching' },
      { name: 'Apache Kafka Streams', url: 'https://kafka.apache.org/documentation/streams/', type: 'streaming' }
    ]
  },
  senior: {
    macos: [
      { name: 'Distributed Systems Design', url: 'https://www.distributed-systems.net/', type: 'architecture' },
      { name: 'Performance Optimization Guide', url: 'https://web.dev/performance/', type: 'performance' },
      { name: 'Security Best Practices', url: 'https://owasp.org/www-project-top-ten/', type: 'security' },
      { name: 'Site Reliability Engineering', url: 'https://sre.google/books/', type: 'reliability' }
    ],
    windows: [
      { name: 'Enterprise Architecture Patterns', url: 'https://docs.microsoft.com/azure/architecture/patterns/', type: 'architecture' },
      { name: 'DevOps Best Practices', url: 'https://docs.microsoft.com/azure/devops/', type: 'devops' },
      { name: 'Cloud Security Framework', url: 'https://docs.microsoft.com/security/', type: 'security' },
      { name: 'Scalability Patterns', url: 'https://docs.microsoft.com/azure/architecture/framework/scalability/', type: 'scalability' }
    ],
    linux: [
      { name: 'High Performance Computing', url: 'https://hpc.llnl.gov/documentation', type: 'performance' },
      { name: 'Container Security', url: 'https://kubernetes.io/docs/concepts/security/', type: 'security' },
      { name: 'Observability Engineering', url: 'https://www.oreilly.com/library/view/observability-engineering/9781492076438/', type: 'monitoring' },
      { name: 'Chaos Engineering', url: 'https://principlesofchaos.org/', type: 'reliability' }
    ]
  }
};
